import {
	Button,
	ConfirmationDialog,
	Loading,
	Table,
	Title,
} from 'src/components';
import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import CourseAssignmentDialog from './CourseAssignmentDialog';
import InstitutionDrawerForm from './InstitutionDrawerForm';
import useStyles from './Institutions-styles';

import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import institutionActions from 'src/store/Institutions/actions';

function Institutions() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const getInstitutions = (page?: number, pageSize?: number) =>
		dispatch(institutionActions.getAll(page, pageSize));
	const remove = (id: number) => dispatch(institutionActions.remove(id));
	const { institutions, isLoading, metadata, page, pageSize } = useSelector(
		(state: RootState) => state.institutions,
	);
	const [drawer, setDrawer] = useState({ institutionId: 0, open: false });
	const [confirmation, setConfirmation] = useState({
		institutionId: 0,
		open: false,
	});
	const [assignment, setAssignment] = useState({
		institution: {},
		open: false,
	});

	useEffect(() => {
		getInstitutions(1, pageSize);
	}, []);

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	function handlePagination(event: any, newPage: number) {
		getInstitutions(newPage, pageSize);
	}

	const columns = [
		{
			key: 'name',
			label: 'Nombre',
			// NOTE:
			// ./src/modules/Private/Courses/Course.tsx[22:8]
			render: (value: any, row: any) => value,
		},
	];

	const actions = [
		{
			label: 'Cursos',
			onClick: (row: any) => {
				setAssignment({ institution: row, open: true });
			},
		},
		{
			label: 'Editar',
			onClick: (row: any) => {
				setDrawer({ institutionId: row.id, open: true });
			},
		},
		{
			label: 'Eliminar',
			onClick: (row: any) => {
				setConfirmation({ institutionId: row.id, open: true });
			},
		},
	];

	return (
		<Grid container>
			<InstitutionDrawerForm
				institutionId={drawer.institutionId}
				onClose={() => {
					setDrawer({ institutionId: 0, open: false });
				}}
				open={drawer.open}
			/>

			<ConfirmationDialog
				onClose={() => {
					setConfirmation({ institutionId: 0, open: false });
				}}
				onConfirm={() => remove(confirmation.institutionId)}
				open={confirmation.open}
				title={'¿Deseas eliminar esta institución?'}
			/>

			<CourseAssignmentDialog
				handleOpen={() => {
					setAssignment({ institution: {}, open: false });
				}}
				institution={assignment.institution}
				open={assignment.open}
			/>

			<Grid item xs={6}>
				<Title
					breadcrumbs={[{ label: 'Instituciones' }]}
					title={'Instituciones'}
				/>
			</Grid>

			<Grid className={classes.buttonContainer} item xs={6}>
				<Button
					actionType={'add'}
					hideLabelOnMobile
					onClick={() => {
						setDrawer({ institutionId: 0, open: true });
					}}
				>
					Agregar
				</Button>
			</Grid>

			<Loading isLoading={isLoading}>
				<Table
					actions={actions}
					columns={columns}
					data={institutions}
					handlePagination={handlePagination}
					metadata={metadata}
					page={page}
				/>
			</Loading>
		</Grid>
	);
}

export default Institutions;
